import { SxProps, Typography } from '@mui/material';

export function QuizFormSectionTitle({
  title,
  sx,
}: {
  title: string;
  sx?: SxProps;
}) {
  return (
    <Typography sx={{ textAlign: 'center', fontWeight: 'bold', ...sx }}>
      {title}
    </Typography>
  );
}
